import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";

const styles = createUseStyles(theme => ({
  notificationsTab: {
    //
  },
}));

export default styles;
